import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllProjects } from '../../../../store/slices/projectsSlice';
import { fetchLeads } from '../../../../store/slices/leadsSlice';

const useProjectApproved = ( operationProjectName) => {
    const dispatch = useDispatch()
    const { projects } = useSelector((state) => state.projects);
    const { leads } = useSelector((state) => state.leads);


    useEffect(() => {
        dispatch(fetchAllProjects());
        dispatch(fetchLeads());
    }, [dispatch]);

    const [projectsApprovedSales, setProjectsApprovedSales] = useState([]);

    useEffect(() => {
        if (projects?.length) {
            const groupedProjects = projects.reduce(
                (acc, project) => {
                    const existingGroup = acc.find(
                        (group) => group.ProjectName === project.ProjectName
                    );

                    if (existingGroup) {
                        // Find existing projects with same TypeService AND same AssignedManagerEmail
                        const sameTypeAndManagerExists = existingGroup.Projects.filter(
                            (p) => p.TypeService === project.TypeService &&
                                JSON.stringify(p.AssignedManagerEmail) === JSON.stringify(project.AssignedManagerEmail)
                        );

                        if (sameTypeAndManagerExists.length > 0) {
                            // Check if any existing project with same TypeService and Manager has isProjecttracking: true
                            const hasTrackingTrue = sameTypeAndManagerExists.some(p => p.isProjecttracking === true);

                            // Check if the current project has isProjecttracking: true
                            const currentProjectIsTracking = project.isProjecttracking === true;

                            if (hasTrackingTrue && currentProjectIsTracking) {
                                // If both existing and current project have tracking true, keep both
                                existingGroup.Projects.push(project);
                            } else if (hasTrackingTrue && !currentProjectIsTracking) {
                                // If existing has tracking true but current is false, skip adding current project
                                // Do nothing - don't add the false one if true already exists
                            } else if (!hasTrackingTrue && currentProjectIsTracking) {
                                // If existing has tracking false but current is true, remove all false ones and add true
                                existingGroup.Projects = existingGroup.Projects.filter(
                                    (p) => !(p.TypeService === project.TypeService &&
                                        JSON.stringify(p.AssignedManagerEmail) === JSON.stringify(project.AssignedManagerEmail))
                                );
                                existingGroup.Projects.push(project);
                            } else {
                                // Both have tracking false - add the project
                                existingGroup.Projects.push(project);
                            }
                        } else {
                            // No duplicate TypeService and Manager combination yet → just push
                            existingGroup.Projects.push(project);
                        }
                    } else {
                        acc.push({
                            AssignedGroup: project.AssignedGroup,
                            ProjectName: project.ProjectName,
                            DateRequested: project.DateRequested,
                            ProjectDueDate: project.ProjectDueDate,
                            Projects: [project],
                        });
                    }

                    return acc;
                },
                []
            );
            const excludedStatuses = ["Won", "won", "Won Recurring", "won recurring"];

            const filteredLeads = leads.filter(
                (lead) => excludedStatuses.includes(lead.Status)
            );

            // Sort leads by createdAt date (newest first)
            const sortedLeads = filteredLeads.sort((a, b) => {
                const dateA = new Date(a.createdAt || a.LeadDate);
                const dateB = new Date(b.createdAt || b.LeadDate);
                return dateB - dateA; // Descending order (newest first)
            });

            // Create merged array where leads get their matching projects
            const mergedArray = sortedLeads.map(lead => {
                // Find projects that match the lead's ProjectName
                const matchingProjects = groupedProjects.filter(
                    project => project.ProjectName === lead.ProjectName
                );

                const allProjects = matchingProjects.flatMap(mp => mp.Projects || []);

                const filteredMatchingProjects = matchingProjects.map(mp => {
                    return {
                        ...mp,
                        Projects: (mp.Projects || []).filter(proj => {
                            const hasTrackingChild = allProjects.some(child =>
                                child.oldprojectid === proj._id &&
                                child.isProjecttracking === true &&
                                child.TypeService === proj.TypeService
                            );

                            return !(proj.isProjecttracking === false && hasTrackingChild);
                        })
                    };
                });
                // If projects found, add them to the lead
                if (filteredMatchingProjects.length > 0) {
                    return {
                        ...lead,
                        projects: filteredMatchingProjects.flatMap(project => project.Projects || [])
                    };
                }
                return {
                    ...lead,
                    projects: []
                };
            });
            setProjectsApprovedSales(mergedArray);
        }
    }, [projects,
        leads
    ]);

    const [matchedApprovedProject, setMatchedApprovedProject] = useState([])

    useEffect(() => {
        if (operationProjectName) {
            const matchedProject = projectsApprovedSales?.find((proj) => proj?.ProjectName === operationProjectName);
            setMatchedApprovedProject([matchedProject])
        }

    }, [projectsApprovedSales, operationProjectName])

    return ({
        matchedApprovedProject,
        projectsApprovedSales
    }
        
    )
}

export default useProjectApproved
